var map = {
	"./01.webm": 350,
	"./1000X.svg": 259,
	"./5ire.png": 558,
	"./5ire.svg": 135,
	"./ANALOG logo 1.svg": 351,
	"./ANMLPartner.svg": 352,
	"./ASTRAPartner.svg": 353,
	"./Anyswap.png": 559,
	"./Anyswap.svg": 560,
	"./Artwork.svg": 561,
	"./Artwork_gmx.svg": 562,
	"./BAGCPartner.svg": 354,
	"./Banxa.png": 563,
	"./BgSmartTrading.png": 564,
	"./COINZIXPartner.svg": 165,
	"./DAMEXPartner.svg": 166,
	"./DEXYNTH.png": 565,
	"./DEXYNTHIcon.svg": 254,
	"./DEXYNTHLogo.svg": 566,
	"./DEXYNTHSTATIC.png": 260,
	"./DEXYNTH_OG.png": 567,
	"./DROP_DOWN.svg": 261,
	"./Delivering a superior.png": 262,
	"./DexynthPng.png": 568,
	"./DiscordBlackIcon.svg": 569,
	"./DiscordDefault.svg": 570,
	"./DiscordIcon.svg": 571,
	"./DiscordVariant2.svg": 572,
	"./EFFICIENT LIQUIDITY.svg": 263,
	"./FONDO_SMART_TRADING.svg": 355,
	"./FONDO_SOMBRA_VERDE.svg": 573,
	"./FiveIREPartner.svg": 356,
	"./Hop.png": 574,
	"./Hop.svg": 575,
	"./Hop_dark.png": 576,
	"./Hop_dark.svg": 577,
	"./LAUNCH.svg": 357,
	"./LOAD-CHICO.gif.gif": 578,
	"./LOADING-GIF.gif": 579,
	"./MEEIROPartner.svg": 358,
	"./MediumIcon.svg": 580,
	"./NO KYC.svg": 264,
	"./NUMEN WEBPARTNER.svg": 581,
	"./OBSC.svg": 167,
	"./ONOMYPartner.svg": 359,
	"./OUR OWN DON.svg": 265,
	"./OUR PARTNERS.png": 266,
	"./OUTERPartner.svg": 168,
	"./POWERED BY 1.png": 582,
	"./POWERED BY.png": 583,
	"./Prasaga 2 1.svg": 169,
	"./REAL YIELD PROTOCOL.svg": 267,
	"./SMART TRADING.png": 268,
	"./STAY_TUNED_FOR_THE_BIG_REVEAL_.svg": 269,
	"./SYNTHETIC TRADING.svg": 270,
	"./ShardeumPartner.svg": 170,
	"./Star1.svg": 171,
	"./Star2.svg": 271,
	"./Subject_to_change.svg": 360,
	"./Synapse.png": 584,
	"./Synapse.svg": 585,
	"./T-60DAYS.svg": 361,
	"./TelegramIcon.svg": 586,
	"./TwitterIcon.svg": 587,
	"./VERICHAINS.svg": 172,
	"./YellowPartner.svg": 173,
	"./ZETACHAIN.svg": 272,
	"./berachain.png": 161,
	"./berachain.svg": 588,
	"./binance.png": 589,
	"./boton-off.png": 590,
	"./boton-on.png": 591,
	"./bscscan.png": 592,
	"./btn_big_arbitrum.png": 593,
	"./btn_big_avalanche.png": 594,
	"./btn_big_bsc.png": 595,
	"./btn_big_purchasegmx.png": 596,
	"./btn_big_purchasegmx.svg": 597,
	"./button-background.jpg": 598,
	"./buy_gmx.svg": 273,
	"./buy_gmx_bond.svg": 599,
	"./buy_transfer_eth.svg": 600,
	"./coinbaseWallet.png": 362,
	"./coingecko.png": 601,
	"./conrelleno.png": 602,
	"./cross.svg": 603,
	"./dexynth-features.png": 604,
	"./dexynth-logo-green.png": 274,
	"./flag_en.svg": 605,
	"./flag_es.svg": 606,
	"./flag_fr.svg": 607,
	"./flag_ja.svg": 608,
	"./flag_ko.svg": 609,
	"./flag_ru.svg": 610,
	"./flag_zh.svg": 611,
	"./fuckies-back.jpg": 612,
	"./fuckies-buttons/BTC-OFF.png": 275,
	"./fuckies-buttons/BTC-ON.png": 276,
	"./fuckies-buttons/CASH-OUT-DONE.png": 613,
	"./fuckies-buttons/CASH-OUT-HOVER.png": 614,
	"./fuckies-buttons/CASH-OUT-OFF.png": 615,
	"./fuckies-buttons/ETH-OFF.png": 277,
	"./fuckies-buttons/ETH-ON.png": 278,
	"./fuckies-buttons/GO-OFF.png": 363,
	"./fuckies-buttons/GO-ON.png": 279,
	"./fuckies-buttons/LONG-OFF.png": 280,
	"./fuckies-buttons/LONG-ON.png": 281,
	"./fuckies-buttons/SHORT-OFF.png": 282,
	"./fuckies-buttons/SHORT-ON.png": 283,
	"./fuckies/BOTON-1.png": 364,
	"./fuckies/back-numbers-fuckies.png": 616,
	"./fuckies/back-numbers-usdt.png": 617,
	"./fuckies/boton-cash.png": 618,
	"./fuckies/box-fondo.png": 182,
	"./fuckies/gogogo.png": 619,
	"./fuckies/price-back.png": 215,
	"./fuckies/select-on-pair.png": 620,
	"./fuckies/select-operation.png": 621,
	"./fuckies/testFuckies.png": 284,
	"./full-star.svg": 622,
	"./gif-unscreen.gif": 174,
	"./glp_icon.svg": 623,
	"./gmx-logo-final-white-small.png": 624,
	"./gmx-logo-final-white.png": 625,
	"./gmx-logo-final.png": 626,
	"./gmx-logo-glow.png": 627,
	"./gmx-logo-with-name.svg": 628,
	"./gmx_logo.svg": 629,
	"./graphite-01.png": 630,
	"./ic-communityproject.svg": 631,
	"./ic_arbitrum_16.svg": 120,
	"./ic_arbitrum_24.svg": 632,
	"./ic_arbitrum_96.svg": 140,
	"./ic_arbitrum_hover_16.svg": 633,
	"./ic_arrowleft16.svg": 634,
	"./ic_arrowright16.svg": 635,
	"./ic_avalanche_16.svg": 121,
	"./ic_avalanche_24.svg": 636,
	"./ic_avalanche_96.svg": 141,
	"./ic_avax_24.svg": 637,
	"./ic_avax_30.svg": 285,
	"./ic_avax_40.svg": 638,
	"./ic_banxa.svg": 216,
	"./ic_binance_logo.svg": 217,
	"./ic_bnb_24.svg": 639,
	"./ic_bnb_40.svg": 640,
	"./ic_bsc.svg": 103,
	"./ic_bsc_96.svg": 641,
	"./ic_btc.b_24.svg": 642,
	"./ic_btc.b_40.svg": 643,
	"./ic_btc_24.svg": 644,
	"./ic_btc_40.svg": 645,
	"./ic_busd_24.svg": 646,
	"./ic_busd_40.svg": 647,
	"./ic_buy_glp.svg": 286,
	"./ic_cash.png": 648,
	"./ic_cash.svg": 649,
	"./ic_checked.svg": 175,
	"./ic_coingecko_16.svg": 287,
	"./ic_coingecko_hover_16.svg": 650,
	"./ic_convert_down.svg": 288,
	"./ic_copy_16.svg": 289,
	"./ic_cost.svg": 290,
	"./ic_dai_24.svg": 651,
	"./ic_dai_40.svg": 652,
	"./ic_discord.svg": 291,
	"./ic_eth_24.svg": 653,
	"./ic_eth_40.svg": 654,
	"./ic_frax_24.svg": 655,
	"./ic_frax_40.svg": 656,
	"./ic_github.svg": 657,
	"./ic_glp_24.svg": 218,
	"./ic_glp_40.svg": 292,
	"./ic_glp_custom.svg": 293,
	"./ic_gmx.svg": 658,
	"./ic_gmx_24.svg": 659,
	"./ic_gmx_30.svg": 660,
	"./ic_gmx_40.svg": 661,
	"./ic_gmx_64.svg": 662,
	"./ic_gmx_arbitrum.svg": 294,
	"./ic_gmx_avax.svg": 295,
	"./ic_gmx_big.svg": 663,
	"./ic_gmx_custom.svg": 296,
	"./ic_gmx_footer.svg": 664,
	"./ic_hop.svg": 297,
	"./ic_info.svg": 665,
	"./ic_language24.svg": 176,
	"./ic_link_24.svg": 666,
	"./ic_link_40.svg": 667,
	"./ic_liquidity.svg": 298,
	"./ic_medium.svg": 668,
	"./ic_menu_dots.svg": 669,
	"./ic_metamask_16.svg": 299,
	"./ic_metamask_hover_16.svg": 670,
	"./ic_mim_24.svg": 671,
	"./ic_mim_40.svg": 672,
	"./ic_multiswap.svg": 219,
	"./ic_new_link_16.svg": 300,
	"./ic_olympus.svg": 673,
	"./ic_olympus_arbitrum.svg": 301,
	"./ic_selector_dropdowns.svg": 674,
	"./ic_settings_16.svg": 302,
	"./ic_settings_24.svg": 675,
	"./ic_sign in_16.svg": 676,
	"./ic_sign_out_16.svg": 303,
	"./ic_simpleswaps.svg": 304,
	"./ic_stats.svg": 305,
	"./ic_stats_big.svg": 677,
	"./ic_synapse.svg": 220,
	"./ic_telegram.svg": 306,
	"./ic_tether_24.svg": 678,
	"./ic_tokens.svg": 679,
	"./ic_totaluser.svg": 307,
	"./ic_trading.svg": 308,
	"./ic_transfer_avax.svg": 680,
	"./ic_twitter.svg": 309,
	"./ic_uni_24.svg": 681,
	"./ic_uni_40.svg": 682,
	"./ic_usdc.e_24.svg": 683,
	"./ic_usdc.e_40.svg": 684,
	"./ic_usdc_24.svg": 685,
	"./ic_usdc_40.svg": 686,
	"./ic_usdg_40.svg": 687,
	"./ic_usdt_24.svg": 688,
	"./ic_usdt_40.svg": 689,
	"./ic_wallet_24.svg": 310,
	"./ic_wavax_24.svg": 690,
	"./ic_wavax_40.svg": 691,
	"./ic_wbnb_40.svg": 692,
	"./ic_wbtc_24.svg": 693,
	"./ic_wbtc_40.svg": 694,
	"./ic_weth_24.svg": 695,
	"./ic_weth_40.svg": 696,
	"./iota.svg": 162,
	"./lg_arbitrum.svg": 697,
	"./logo_GMX.svg": 698,
	"./logo_GMX_small.svg": 699,
	"./long.svg": 311,
	"./metamask-text.svg": 700,
	"./metamask.png": 312,
	"./myriaPartner.svg": 365,
	"./new-dexynth-logo.png": 132,
	"./numen-partner.svg": 177,
	"./opbnb-logo.png": 701,
	"./page-not-found.svg": 702,
	"./partners-svg/Analog.svg": 703,
	"./partners-svg/Coinzix.svg": 704,
	"./partners-svg/Damex.svg": 705,
	"./partners-svg/NumenLogo.svg": 706,
	"./partners-svg/Obscuro.svg": 707,
	"./partners-svg/OuterRing.svg": 708,
	"./partners-svg/Prasaga.svg": 709,
	"./partners-svg/Shardeum.svg": 710,
	"./partners-svg/TradingView.svg": 313,
	"./partners-svg/Verichains.svg": 711,
	"./partners-svg/Yellow.svg": 712,
	"./partners-svg/zkSync BCO.svg": 713,
	"./position-share-bg.png": 714,
	"./powered_by.svg": 366,
	"./shardeum.webp": 158,
	"./shimmer.svg": 256,
	"./short.svg": 314,
	"./swap.svg": 315,
	"./synthrPartner.svg": 367,
	"./ten.png": 715,
	"./ten.svg": 160,
	"./tokenlogo/AAPLUSD.svg": 368,
	"./tokenlogo/AAVEUSD.svg": 369,
	"./tokenlogo/ABNBUSD.svg": 370,
	"./tokenlogo/ADAUSD.svg": 371,
	"./tokenlogo/ALGOUSD.svg": 372,
	"./tokenlogo/AMDUSD.svg": 373,
	"./tokenlogo/AMZNUSD.svg": 374,
	"./tokenlogo/APEUSD.svg": 375,
	"./tokenlogo/ATOMUSD.svg": 376,
	"./tokenlogo/AUDUSD.svg": 377,
	"./tokenlogo/AVAXUSD.svg": 378,
	"./tokenlogo/BATUSD.svg": 379,
	"./tokenlogo/BAUSD.svg": 380,
	"./tokenlogo/BCHUSD.svg": 381,
	"./tokenlogo/BNBUSD.svg": 382,
	"./tokenlogo/BTCUSD.svg": 383,
	"./tokenlogo/CHZUSD.svg": 384,
	"./tokenlogo/COMPUSD.svg": 385,
	"./tokenlogo/CRVUSD.svg": 386,
	"./tokenlogo/DASHUSD.svg": 387,
	"./tokenlogo/DIAUSD.svg": 388,
	"./tokenlogo/DISUSD.svg": 389,
	"./tokenlogo/DOGEUSD.svg": 390,
	"./tokenlogo/DOTUSD.svg": 391,
	"./tokenlogo/ENJUSD.svg": 392,
	"./tokenlogo/EOSUSD.svg": 393,
	"./tokenlogo/ETCUSD.svg": 394,
	"./tokenlogo/ETHUSD.svg": 395,
	"./tokenlogo/EURCHF.svg": 396,
	"./tokenlogo/EURGBP.svg": 397,
	"./tokenlogo/EURJPY.svg": 398,
	"./tokenlogo/EURNOK.svg": 399,
	"./tokenlogo/EURSEK.svg": 400,
	"./tokenlogo/EURUSD.svg": 401,
	"./tokenlogo/FTMUSD.svg": 402,
	"./tokenlogo/GBPUSD.svg": 403,
	"./tokenlogo/GMEUSD.svg": 404,
	"./tokenlogo/GOOGLUSD.svg": 405,
	"./tokenlogo/GRTUSD.svg": 406,
	"./tokenlogo/ICPUSD.svg": 407,
	"./tokenlogo/INTCUSD.svg": 408,
	"./tokenlogo/IWMUSD.svg": 409,
	"./tokenlogo/KOUSD.svg": 410,
	"./tokenlogo/KRW.svg": 411,
	"./tokenlogo/LINKUSD.svg": 412,
	"./tokenlogo/LTCUSD.svg": 413,
	"./tokenlogo/MANAUSD.svg": 414,
	"./tokenlogo/MATICUSD.svg": 415,
	"./tokenlogo/MAUSD.svg": 416,
	"./tokenlogo/MCDUSD.svg": 417,
	"./tokenlogo/METAUSD.svg": 418,
	"./tokenlogo/MKRUSD.svg": 419,
	"./tokenlogo/MSFTUSD.svg": 420,
	"./tokenlogo/NEARUSD.svg": 421,
	"./tokenlogo/NKEUSD.svg": 422,
	"./tokenlogo/NOK.svg": 423,
	"./tokenlogo/NVDAUSD.svg": 424,
	"./tokenlogo/NZDUSD.svg": 425,
	"./tokenlogo/OMGUSD.svg": 426,
	"./tokenlogo/PFEUSD.svg": 427,
	"./tokenlogo/PYPLUSD.svg": 428,
	"./tokenlogo/QNTUSD.svg": 429,
	"./tokenlogo/QQQUSD.svg": 430,
	"./tokenlogo/SANDUSD.svg": 431,
	"./tokenlogo/SBUXUSD.svg": 432,
	"./tokenlogo/SHIBUSD.svg": 433,
	"./tokenlogo/SNAPUSD.svg": 434,
	"./tokenlogo/SNXUSD.svg": 435,
	"./tokenlogo/SOLUSD.svg": 436,
	"./tokenlogo/SPYUSD.svg": 437,
	"./tokenlogo/THETAUSD.svg": 438,
	"./tokenlogo/TRXUSD.svg": 439,
	"./tokenlogo/TSLAUSD.svg": 440,
	"./tokenlogo/UNIUSD.svg": 441,
	"./tokenlogo/USDCAD.svg": 442,
	"./tokenlogo/USDCHF.svg": 443,
	"./tokenlogo/USDCNH.svg": 444,
	"./tokenlogo/USDJPY.svg": 445,
	"./tokenlogo/USDKRW.svg": 446,
	"./tokenlogo/USDMXN.svg": 447,
	"./tokenlogo/USDSGD.svg": 448,
	"./tokenlogo/USDZAR.svg": 449,
	"./tokenlogo/VUSD.svg": 450,
	"./tokenlogo/WMTUSD.svg": 451,
	"./tokenlogo/XAGUSD.svg": 452,
	"./tokenlogo/XAUUSD.svg": 453,
	"./tokenlogo/XLMUSD.svg": 454,
	"./tokenlogo/XMRUSD.svg": 455,
	"./tokenlogo/XRPUSD.svg": 456,
	"./tokenlogo/XTZUSD.svg": 457,
	"./tokenlogo/YFIUSD.svg": 458,
	"./tokenlogo/ZECUSD.svg": 459,
	"./tokenlogo/_LOGO SHARDEUM BLANCO.svg": 460,
	"./tokenlogo/_LOGO ZKSYNC BLANCO.svg": 461,
	"./trading.jpg": 716,
	"./tv.png": 316,
	"./users-logo.png": 146,
	"./verichains.jpeg": 717,
	"./wallet-connect-text.svg": 718,
	"./walletconnect-circle-blue.svg": 462,
	"./wave-01.png": 719,
	"./wave-02.png": 720,
	"./zetachain.png": 255,
	"./zksync.svg": 159,
	"./zksynk-logo.png": 721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;